var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColorPickerView',{staticClass:"color-picker-wrap",attrs:{"color":_vm.color,"disableUpdateBaseColor":_vm.disableUpdateBaseColor},on:{"change":_vm.handleEmitEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }